module.exports = __webpack_public_path__ + "static/media/surfair_card_3.b7ee49bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/surfair_card_3.png
// module id = 520
// module chunks = 0